import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA0Sob7AH3wH9UWYEp2qxZc645KwHqxt_w",
  authDomain: "challenge-4d469.firebaseapp.com",
  projectId: "challenge-4d469",
  storageBucket: "challenge-4d469.appspot.com",
  messagingSenderId: "13454605662",
  appId: "1:13454605662:web:ab75cc303b567e520a63cf",
  measurementId: "G-ZMVGCSV7R1"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };